export default "__VITE_ASSET__cfa6e4a9__"